import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../Forms/MdmFormProps";
import { useResolveGeoCoordinates } from "../../../GoogleMaps/useResolveGeoCoordinates";
import { CountrySelect } from "../../../Locations/CountrySelect";
import { Edc } from "../../Edc";
import { GeoCoordinatesAddressTextField } from "../../../Supplier/Form/GeoCoordinatesAddressTextField";
import { TextFieldInput } from "../../../Forms/TextFieldInput";
import { isNotEmpty } from "../../../Utils/strings";

export const EdcOptionalAddress = ({ disabledFields }: MdmFormProps) => {
  const {
    control,
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext<Edc>();

  const { resolveGeoCoordinatesIfAddressIsComplete } = useResolveGeoCoordinates<Edc>(
    "AltStreet",
    "AltZipCode",
    "AltCity",
    "AltLatitude",
    "AltLongitude"
  );

  return (
    <BorderedFormGrid>
      {/* FIRST ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="AltStreet"
          control={control}
          label="Street"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("AltLatitude", fallbackGeoCoordinates.latitude);
            setValue("AltLongitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("AltStreet"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldInput
          name="AltRegion"
          control={control}
          label="Region"
          required
          disabledFields={disabledFields}
        />
      </Grid>
      {/* PLACEHOLDER DEFAULT STOP TIME */}
      <Grid item xs={4} />
      {/* SECOND ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="AltZipCode"
          control={control}
          label="Postcode"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("AltLatitude", fallbackGeoCoordinates.latitude);
            setValue("AltLongitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("AltZipCode"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <CountrySelect control={control} name="AltCountryId" />
      </Grid>
      {/* PLACEHOLDER EQUIPEMENT RESTRICTION */}
      <Grid item xs={4} />
      {/* THIRD ROW */}
      <Grid item xs={4}>
        <TextFieldInput
          name="AltZipArea"
          control={control}
          label="Postcode Area"
          disabledFields={disabledFields}
        />
      </Grid>
      {/* PLACEHOLDER */}
      <Grid item xs={4} />
      <Grid item xs={4} />
      {/* FOURTH ROW */}
      <Grid item xs={4}>
        <GeoCoordinatesAddressTextField
          name="AltCity"
          control={control}
          label="City"
          disabledFields={disabledFields}
          triggerGeoCoordinatesCalculation={(fallbackGeoCoordinates) => {
            setValue("AltLatitude", fallbackGeoCoordinates.latitude);
            setValue("AltLongitude", fallbackGeoCoordinates.longitude);
            if (isNotEmpty(getValues("AltCity"))) resolveGeoCoordinatesIfAddressIsComplete();
          }}
        />
      </Grid>
      {/* PLACEHOLDER ISO COUNTRY CODE */}
      <Grid item xs={4} />
      <Grid item xs={4} />
    </BorderedFormGrid>
  );
};
